const { brandConfig } = require("../lib/brand_config");

// eslint-disable-next-line import/prefer-default-export
export const HUNTERS_EMAIL_SUPPORT = brandConfig("hunterEmail") || "madeleine@bookastreetartist.com";
